import * as x1 from "./credit-card-icons.png";
import { SLIcon } from "../SLIcon";

export const CreditCardIcons = SLIcon(x1, x1, x1);



// WEBPACK FOOTER //
// ./src/components/Icons/CreditCardIcons/CreditCardIcons.tsx